<template>
  <div class="banner-container">
    <div class="banner-wrapper" ref="bannerWrapper">
      <div 
        class="banner-slide" 
        v-for="(image, index) in imageList" 
        :key="index"
        :class="{ active: currentIndex === index }"
      >
        <img :src="image" :alt="getAlt(index)" />
      </div>
    </div>
    <div class="banner-btn prev-btn" @click="prevSlide">
      <img src="@/assets/image/banner-prev.png" alt="上一张" />
    </div>
    <div class="banner-btn next-btn" @click="nextSlide">
      <img src="@/assets/image/banner-next.png" alt="下一张" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    imageList: {
      type: Array,
      required: true,
      default: () => []
    },
    imageAltList: {
      type: Array,
      default: () => [],
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentIndex: 0,
      timer: null
    };
  },
  mounted() {
    if (this.duration > 0 && this.imageList.length > 1) {
      this.startAutoPlay();
    }
  },
  beforeUnmount() {
    this.stopAutoPlay();
  },
  watch: {
    duration(newVal) {
      this.stopAutoPlay();
      if (newVal > 0 && this.imageList.length > 1) {
        this.startAutoPlay();
      }
    },
    imageList() {
      this.stopAutoPlay();
      if (this.duration > 0 && this.imageList.length > 1) {
        this.startAutoPlay();
      }
    }
  },
  methods: {
    getAlt(index) {
      return this.imageAltList?.[index] || `Banner ${index + 1}`;
    },
    prevSlide() {
      if (this.imageList.length === 0) return;
      this.currentIndex = (this.currentIndex - 1 + this.imageList.length) % this.imageList.length;
      this.resetAutoPlay();
    },
    nextSlide() {
      if (this.imageList.length === 0) return;
      this.currentIndex = (this.currentIndex + 1) % this.imageList.length;
      this.resetAutoPlay();
    },
    startAutoPlay() {
      if (this.duration > 0 && this.imageList.length > 1) {
        this.timer = setInterval(() => {
          this.nextSlide();
        }, this.duration);
      }
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    resetAutoPlay() {
      this.stopAutoPlay();
      if (this.duration > 0 && this.imageList.length > 1) {
        this.startAutoPlay();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.banner-container {
  position: relative;
  width: 100%;
  height: 460px;
  overflow: hidden;
  
  .banner-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    
    .banner-slide {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity 0.5s ease-in-out;
      
      &.active {
        opacity: 1;
        z-index: 1;
      }
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  
  .banner-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    
    &:hover {
      opacity: 0.8;
    }
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    
    &.prev-btn {
      left: 24px;
    }
    
    &.next-btn {
      right: 24px;
    }
  }
}
</style>
